"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Csv_1 = __importDefault(require("./libs/Csv"));
const Xlsx_1 = __importDefault(require("./libs/Xlsx"));
async function parseFile(file) {
    const parts = file.name.split(".");
    const extension = parts[parts.length - 1];
    switch (extension) {
        case "xlsx":
            return Xlsx_1.default(await fileToUint8Array(file));
        default:
            // 'csv'
            return await Csv_1.default(file);
    }
}
exports.default = parseFile;
async function fileToUint8Array(file) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = function (_) {
            resolve(new Uint8Array(reader.result));
        };
        reader.readAsArrayBuffer(file);
    });
}
